//jsxhook

import { Modal } from "@sixty-six-north/ui-system"
import React from "react"
import { useTranslation } from "react-i18next"
import { NotifyBackInStockProps, NotifyBackInStock } from "./NotifyBackInStock"

interface NotifyBackInStockModalProps extends NotifyBackInStockProps {
  show: boolean
  close: () => void
}

export const NotifyBackInStockModal: React.FC<NotifyBackInStockModalProps> = ({
  product,
  show,
  close
}) => {
  const { t } = useTranslation("product")

  return (
    <Modal
      show={show}
      close={close}
      title={t("product:notifyBackInStockTitle")}
      width={[690]}
    >
      <NotifyBackInStock product={product} />
    </Modal>
  )
}

export default NotifyBackInStockModal
